import { ButtonColors } from '@chiroup/components/Button';
import React, { use, useState } from 'react';
import { ToastContext, ToastTypes } from '../../../contexts/toast.context';
import formService from '../../../services/form.service';
import Modal from '../../common/Modal';

type Props = {
  isOpen: boolean;
  id: number | null;
  close: () => void;
  refetch: () => void;
};

const DeleteFormModal: React.FC<Props> = ({ isOpen, id, close, refetch }) => {
  const { createToast } = use(ToastContext);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const onDelete = async () => {
    if (!id) return;
    setIsDeleting(true);

    try {
      await formService.del(id);
      refetch();
    } catch (err) {
      createToast({
        title: 'Error!',
        description: <>Failed to delete Form!</>,
        type: ToastTypes.Fail,
        duration: 5000,
      });
    }

    setIsDeleting(false);
    close();
  };

  const footerButtons = [
    {
      text: 'Yes',
      onClick: () => onDelete(),
      color: ButtonColors.plain,
      disabled: isDeleting,
      className: 'border border-gray-300 dark:border-dark-gray-500',
    },
    { text: 'No', onClick: close },
  ];

  return (
    <Modal
      isOpen={isOpen}
      close={close}
      header={{ title: 'Do you want to delete this form?' }}
      footer={{ buttons: footerButtons }}
    >
      <></>
    </Modal>
  );
};

export default DeleteFormModal;
